<template>
  <div class="card-body py-3">
    <h3 class="mb-0 t-500">
      Type of research group
      <editable v-if="isLoaded && $can.edit('research_group', researchGroup.rw_access)" :isActive="false"
        :text="`Edit`"
        @create="handleEdit()">
      </editable>
    </h3>

    <ul v-if="isLoaded" class="ml-0 mt-3 mb-0 pl-0">
      <li v-for="(t, index) in researchGroup.research_group_types" :key="index" class="badge badge-pill badge-secondary--white position-relative mt-0 mb-0 mr-2 bd-radius word-overflow">
        {{ t.name }}
      </li>
    </ul>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import Editable from '@/components/shared/Editable'

export default {
  name: 'researchGroupType',
  components: {
    Spinner,
    Editable
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleEdit () {
      this.$events.$emit(`modal:research_group:open:create`, this.researchGroup)
    }
  }
}
</script>
